import { ActivityCanvas } from './activity-canvas';
import { useWorkspace } from './context';
import type { CanvasTarget } from './types';
import { useCanvasCopy } from './canvas-copy';

/**
 * Activity is subordinate to the object that produced it. Keeping this small
 * adapter in workspace-owned code lets Skill, Result and Agent canvases share
 * the same trace UI without opening a second canvas.
 */
export function CanvasActivityTab({ target }: { target: CanvasTarget }) {
  const ws = useWorkspace();
  const canvasCopy = useCanvasCopy();
  const messageId = target.activityMessageId;
  if (!messageId) {
    return <p className="ws-muted">{canvasCopy.activityUnavailable}</p>;
  }
  return (
    <ActivityCanvas
      messageId={messageId}
      step={target.step}
      target={{
        kind: 'activity',
        id: messageId,
        tab: target.activityTab,
        step: target.step,
      }}
      onTabChange={(next) => ws.openCanvas({ ...target, tab: 'activity', activityTab: next })}
    />
  );
}
